/**
 * Creates and returns an array of timeZoneIds with the startTimeZoneId as the first or base timeZone.
 * If no time zones are provided, an empty array is returned.
 * Returns only unique timeZoneIds.
 */
export function createTimeZoneArray(StartTimeZoneId: string, EndTimeZoneId: string): string[] {
    let timeZones: string[] = [];

    if (StartTimeZoneId) {
        timeZones.push(StartTimeZoneId);
    }

    if (EndTimeZoneId && timeZones.indexOf(EndTimeZoneId) == -1) {
        timeZones.push(EndTimeZoneId);
    }

    return timeZones;
}
